// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_DESKTOP: 74,
  H_DESKTOP_OFFSET: 80 - 16,
  H_HOME_DESKTOP: 193,
  H_HOME_MOBILE: 128,
};

export const NAV = {
  W_VERTICAL: 240,
  W_MINI: 88,
};
